import { render, staticRenderFns } from "./mapel.vue?vue&type=template&id=041ba403&"
import script from "./mapel.vue?vue&type=script&lang=js&"
export * from "./mapel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports